var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LMarker',{key:_vm.id,ref:"marker",class:{
    'event-marker--visible': _vm.visible,
  },attrs:{"id":_vm.htmlId,"options":{ id: _vm.id },"lat-lng":_vm.latLng,"icon":_vm.icon},on:{"click":function($event){return _vm.$emit('click', _vm.id)}}})}
var staticRenderFns = []

export { render, staticRenderFns }